import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { comparison } from '../data/comparison';
export function ComparisonSection() {
  return <section className="defer-paint w-full bg-mist py-12 sm:py-14" aria-labelledby="comparison-heading" data-id="element-26" data-mp="39e7p3qdoittf">
      <div className="mx-auto max-w-5xl px-6" data-id="element-27" data-mp="34ev5rfm0o4vl">
        <SectionHeading eyebrow="El antes y el después" title={<span id="comparison-heading" data-id="element-29" data-mp="2zhwer5xnge1m">Sin MEGAPACK vs. con MEGAPACK</span>} data-id="element-28" data-mp="34dtqeyxyww82" />

        {/* Móvil: una tarjeta por fila, sin scroll horizontal. */}
        <ul className="mt-9 space-y-3 md:hidden" data-id="element-30" data-mp="2qf3kctt67m7k">
          {comparison.map(row => <li key={row.topic} className="rounded-2xl border border-line bg-shell p-4" data-id="element-31" data-mp="2lhbu0486c85h">
              <p className="font-sans text-[0.82rem] font-semibold text-ink" data-id="element-32" data-mp="on7bjrye0qgh">
                {row.topic}
              </p>

              <div className="mt-3 space-y-2" data-id="element-33" data-mp="jq8kjia0szmi">
                <p className="flex gap-2 font-sans text-[0.8rem] leading-snug text-muted" data-id="element-34" data-mp="3ael3bkioy5f0">
                  <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-alert" strokeWidth={3} aria-hidden="true" data-id="element-35" data-mp="3eh7q370i905c" />
                  <span data-id="element-36" data-mp="35frqzvf54kgf">
                    <span className="mr-1 font-semibold uppercase tracking-[0.1em] text-alert" data-id="element-37" data-mp="35h2urv8l5s7j">
                      Sin:
                    </span>
                    {row.without}
                  </span>
                </p>
                <p className="flex gap-2 rounded-xl bg-green-soft px-3 py-2 font-sans text-[0.8rem] font-medium leading-snug text-ink" data-id="element-38" data-mp="1yrmf4kg6rxf">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-green" strokeWidth={3} aria-hidden="true" data-id="element-39" data-mp="3oevxoxj7m24x" />
                  <span data-id="element-40" data-mp="kpsldslkingz">
                    <span className="mr-1 font-semibold uppercase tracking-[0.1em] text-green-deep" data-id="element-41" data-mp="kqanv6ytpxxc">
                      Con:
                    </span>
                    {row.with}
                  </span>
                </p>
              </div>
            </li>)}
        </ul>

        {/* Desktop: la tabla completa, ya sin scroll lateral. */}
        <div className="mt-9 hidden overflow-hidden rounded-3xl border border-line bg-shell md:block" data-id="element-42" data-mp="kpodrcggf169">
          <table className="w-full table-fixed border-collapse text-left" data-id="element-43" data-mp="gocl0y2a9ztu">
            <caption className="sr-only" data-id="element-44" data-mp="bohxn4hpvsdj">
              Comparación entre enseñar sin el sistema y enseñar con el MEGAPACK
              Educación Física 360.
            </caption>
            <thead data-id="element-45" data-mp="1xvl5j5arhz2">
              <tr className="bg-mist" data-id="element-46" data-mp="1xdgpz8hdxg2">
                <th scope="col" className="w-[24%] px-5 py-4 font-sans text-[10px] font-semibold uppercase tracking-[0.16em] text-muted" data-id="element-47" data-mp="3t3olo6gm3ico">
                  Lo que pasa
                </th>
                <th scope="col" className="px-5 py-4 font-sans text-[10px] font-semibold uppercase tracking-[0.16em] text-alert" data-id="element-48" data-mp="3k41j3hc5c6i1">
                  Sin el sistema
                </th>
                <th scope="col" className="bg-green-soft px-5 py-4 font-sans text-[10px] font-semibold uppercase tracking-[0.16em] text-green-deep" data-id="element-49" data-mp="24llty15q3m5m">
                  Con MEGAPACK EF 360
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-line" data-id="element-50" data-mp="1gsdc03lcvaa8">
              {comparison.map(row => <tr key={row.topic} className="align-top" data-id="element-51" data-mp="1ktff4vie86hh">
                  <th scope="row" className="px-5 py-4 font-sans text-[0.85rem] font-semibold leading-snug text-ink" data-id="element-52" data-mp="1pu34lcqz4f9l">
                    {row.topic}
                  </th>
                  <td className="px-5 py-4" data-id="element-53" data-mp="x44kzwvjtacb">
                    <span className="flex gap-2 font-sans text-[0.85rem] leading-snug text-muted" data-id="element-54" data-mp="124ikgqj33byq">
                      <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-alert" strokeWidth={3} aria-hidden="true" data-id="element-55" data-mp="34r62d0m6tdpd" />
                      {row.without}
                    </span>
                  </td>
                  <td className="bg-green-soft/60 px-5 py-4" data-id="element-56" data-mp="38t14g7bxzv47">
                    <span className="flex gap-2 font-sans text-[0.85rem] font-medium leading-snug text-ink" data-id="element-57" data-mp="38rpxxzr4499e">
                      <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-green" strokeWidth={3} aria-hidden="true" data-id="element-58" data-mp="3ijcfsexyh6l4" />
                      {row.with}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}